import axios from '@tw/shared-ui-components/lib/utils/axios_interceptor';
import { getPdmApiUrl } from "./helper";
import Cookie from "universal-cookie";
import { getVisitorStatus } from "@tw/header-footer/lib/utils/helper";
import { ROLE_FOA } from "@tw/header-footer/lib/utils/constants";
export const getConsigneeData = () => {
  try {
    if (typeof window === "undefined") return {};
    const onBehalfData = JSON.parse(localStorage.getItem("onbehalf"));
    const cookie = new Cookie();
    const isVisitor = getVisitorStatus();
    if (onBehalfData) {
      return {
        consigneeAda: onBehalfData?.ada || "",
        consigneeType: onBehalfData?.loginType || "",
        consigneeMemberType: onBehalfData?.loginMemberType || "",
      };
    } else if (isVisitor) {
      return {
        consigneeAda: cookie.get("vAda") || "",
        consigneeType: ROLE_FOA || "",
        consigneeMemberType: "V" || "",
      };
    } else {
      return {
        consigneeAda: cookie.get("ada") || "",
        consigneeType: cookie.get("role") || "",
        consigneeMemberType: cookie.get("loginType") || "",
      };
    }
  } catch (error) {
    console.log('Error >>', JSON.stringify(error));
  }

};

export const addToCart = async (
  itemCode,
  quantity = 1,
  additionalData = {},
  consigneeAda = null,
  consigneeType = null,
  consigneeMemberType = null
) => {
  const apiUrl = getPdmApiUrl();
  const param = consigneeAda && consigneeType && consigneeMemberType ? {
    itemCode,
    quantity: quantity,
    consigneeAda,
    consigneeType,
    consigneeMemberType,
    ...additionalData,
  } :
    {
      itemCode,
      quantity: quantity,
      ...additionalData,
      ...getConsigneeData(),
    }

  return axios.post(
    `/add-to-cart`,
    { ...param },
    {
      baseURL: apiUrl,
    }
  );
};

export const batchAddToCart = async (products, additionalData = {}) => {
  const apiUrl = getPdmApiUrl();

  return axios.post(
    `/batch-add-to-cart`,
    {
      products,
      ...additionalData,
      ...getConsigneeData(),
    },
    {
      baseURL: apiUrl,
    }
  );
};

export const addToWishlist = async (productCode) => {
  const apiUrl = getPdmApiUrl();
  return axios.post(
    `/add-to-collection`,
    {
      productCode,
    },
    {
      baseURL: apiUrl,
    }
  );
};

export const removeToWishlist = async (productCode) => {
  const apiUrl = getPdmApiUrl();
  return axios.post(
    `/remove-from-collection`,
    {
      collectionList: [{ productCode }],
    },
    {
      baseURL: apiUrl,
    }
  );
};

export const calculateBundleTotal = async (
  promotionCode,
  promotionItemList,
  additionalData = {}
) => {
  const apiUrl = getPdmApiUrl();

  const res = await axios.post(
    `/calculate-bundle-total`,
    {
      promotionCode,
      promotionItemList,
      ...additionalData,
    },
    {
      baseURL: apiUrl,
    }
  );
  return res.data;
};

export const getProductInfo = async (itemCode) => {
  const apiUrl = getPdmApiUrl();
  const res = await axios.post(
    `/products/${itemCode}`,
    {},
    {
      baseURL: apiUrl,
    }
  );
  return res;
};
